import { Node } from './treenode'

export class Document extends Node<string> {
    readonly type = 'document'

    content: string

    constructor(title: string, slug: string, content: string) {
        super(title, slug)
        this.content = content
    }
}
